import React, { useState, useEffect } from 'react';
import Breadcrumb from '../../../../components/partials/Breadcrumb';
import { BiCategory } from 'react-icons/bi';
import { Link, useNavigate, useParams } from 'react-router-dom';
import { Formik, Field } from 'formik';
import { GetProductCategory, Alerts } from '../../../../helpers';
import CKEditorField from '../../../../components/cmp/CKEditorField';
import MediaLibraryPopup from '../../../../components/cmp/MediaLibraryPopup';
import { FiEdit } from "react-icons/fi";
const breadcrumbs = [
  {
    id: 1,
    label: 'Dashboard',
    link: '/',
  },
  {
    id: 2,
    label: 'Categories',
    link: '/app/product/categories',
  },
  {
    id: 3,
    label: 'Update',
    link: '/app/product/categories/edit',
  },
];

const EditCategory = () => {
  const navigate = useNavigate();
  const { id } = useParams();
  const [categories, setCategories] = useState([]);
  const [category, setCategory] = useState('');
  const [showMedia, setShowMedia] = useState(false);
  const [imageFile, setImageFile] = useState('');

  const getCategories = async () => {
    let resp = await GetProductCategory.getAllCategories();
    if (resp && resp.status) {
      setCategories(resp.data);
    }
  };

  const getCategory = async (id) => {
    const resp = await GetProductCategory.getSingleCategory(id);
    console.log(resp);
    if (resp && resp.status) {
      setCategory(resp.data);
      setImageFile(resp.data.category_thumbnail);

    } else {
      Alerts.alertMessage(resp.message, "top-right", "success");
      navigate('/app/product/categories/');
    }
  }

  useEffect(() => {
    getCategories();
    getCategory(id)
  }, [id]);


  const handleSubmit = async (values) => {
    const { parent_category, name, short_description, description, status, is_home } = values;
    const data = {
      parent_id: parent_category,
      title: name,
      short_description,
      description: description,
      media_id: imageFile !== '' ? imageFile.id : '',
      status: status,
      is_home,
      meta_title: values.meta_title,
      meta_description: values.meta_description,
      meta_keywords: values.meta_keywords,
      canonical_url: values.canonical_url,
      robots: values.robots,
      og_title: values.og_title,
      og_description: values.og_description,
      og_image: values.og_image,
      twitter_title: values.twitter_title,
      twitter_description: values.twitter_description,
      twitter_image: values.twitter_image
    };
    let resp = await GetProductCategory.updateCategory(data, id);
    if (resp && resp.status) {
      Alerts.alertMessage(resp.message, "top-right", "success");
      navigate('/app/product/categories/');
    } else {
      Alerts.alertMessage(resp.message, "top-right", "error");
    }
  };

  const handleSelectImage = (image) => {
    setImageFile(image);
    setShowMedia(false);
  }
  return (
    <>
    
      <div className="innerPageWrapper">
        <div className="container-fluid">
          <div className="page-title">
            <h2>
              <BiCategory /> Edit Product Categories
            </h2>
            <Link to="/app/product/categories/" className="btn btn-success">
              <BiCategory /> Categories
            </Link>
          </div>

          <Formik
            enableReinitialize={true}
            initialValues={{
              name: category.title,
              short_description: category.short_description,
              description: category.description,
              parent_category: category.parent_id !== 'null' ? category.parent_id : '',
              // cat_thumb: category.category_thumbnail?.id, 
              status: category.is_active,
              is_home: category.is_home,
              meta_title: category.meta_title,
              meta_description: category.meta_description,
              meta_keywords: category.meta_keywords,
              canonical_url: category.canonical_url,
              robots: category.robots,
              og_title: category.og_title,
              og_description: category.og_description,
              og_image: category.og_image,
              twitter_title: category.twitter_title,
              twitter_description: category.twitter_description,
              twitter_image: category.twitter_image
            }}
            validate={(values) => {
              const errors = {};
              if (!values.name) {
                errors.name = 'Category name is required';
              }
              if (!values.description) {
                errors.description = 'Category description is required';
              }

              return errors;
            }}
            onSubmit={handleSubmit}
          >
            {({
              values,
              errors,
              touched,
              handleChange,
              handleBlur,
              handleSubmit,
              isSubmitting,
              setFieldValue,
            }) => (
              <form onSubmit={handleSubmit}>
                <div className="card">
                  <div className="card-body">
                    <div className="row">
                      <div className="col-md-7">
                        <div className="form-group">
                          <label>Name</label>
                          <input
                            type="text"
                            className="form-control"
                            name="name"
                            onChange={handleChange}
                            onBlur={handleBlur}
                            value={values.name}
                          />
                          {errors.name && touched.name && <span className="help-error">{errors.name}</span>}
                        </div>
                        <div className="form-group">
                          <label>Short Description</label>
                          <textarea
                            className="form-control"
                            name="short_description"
                            onChange={handleChange}
                            onBlur={handleBlur}
                            value={values.short_description}
                          ></textarea>
                          {errors.short_description &&
                            touched.short_description && (
                              <span className="help-error">
                                {errors.short_description}
                              </span>
                            )}
                        </div>
                        <div className="form-group">
                          <label>Description</label>
                          <Field
                            name="description"
                            render={({ field, form }) => (
                              <CKEditorField field={field} form={form} />
                            )}
                          />
                          {errors.description && touched.description && (
                            <span className="help-error">{errors.description}</span>
                          )}
                        </div>

                      </div>
                      <div className="col-md-5">
                        <div className="form-group">
                          <label>Category Thumbnail</label>
                          <div className="dropzone-box">
                            {
                              imageFile !== '' && <img src={imageFile?.path} alt="product_thumbnail" />
                            }
                            {
                              imageFile !== '' ? <button type="button" className="floatBtn" onClick={() => setShowMedia(true)}><FiEdit size={15} /></button> : <>
                                <p>Drop files to upload</p>
                                <p>or</p>
                                <button type="button" onClick={() => setShowMedia(true)} className="choose-btn">Choose file</button>
                              </>
                            }
                          </div>


                        </div>
                        <div className="form-group">
                          <label>Parent Category</label>
                          <select
                            className="form-control"
                            name="parent_category"
                            onChange={handleChange}
                            onBlur={handleBlur}
                            value={values.parent_category}
                          >
                            <option value={''}>---Select Category---</option>
                            {categories.length !== 0 &&
                              categories.map((item) => {
                                if (item.id === category.id) {
                                  return null;
                                }
                                return (
                                  <option value={item.id} key={item.id}>
                                    {item.title}
                                  </option>
                                );
                              })}
                          </select>
                        </div>
                        <div className="form-group">
                          <label>Status</label>
                          <select
                            className="form-control"
                            name="status"
                            onChange={handleChange}
                            onBlur={handleBlur}
                            value={values.status}
                          >
                            <option value={1}>Active</option>
                            <option value={0}>Draft</option>

                          </select>
                        </div>
                        <div className="form-group">
                          <div className="form-check-custom col-md-12 mt-0">
                            <input
                              type="checkbox"
                              id="is_home"
                              name="is_home"
                              checked={values.is_home}
                              onChange={() => {
                                setFieldValue("is_home", !values.is_home)
                              }}
                            />
                            <label htmlFor="is_home">
                              Show on Home
                            </label>
                          </div>

                        </div>
                        <div
                          style={{
                            width: "100%",
                            textAlign: "center",
                            marginTop: 30,
                          }}
                        >
                          <button type="submit" className="btn btn-primary" disabled={isSubmitting}>
                            {isSubmitting ? 'Updating...' : 'Update Now'}
                          </button>
                        </div>
                      </div>
                    </div>
                    {
                      showMedia && <MediaLibraryPopup isMulti={false} show={showMedia} setShowMedia={setShowMedia} handleImageSubmit={handleSelectImage} setFieldValue={setFieldValue} fieldName="cat_thumb" />
                    }
                  </div>
                </div>
                  <div className="card" style={{ marginTop: 20 }}>
                    <div className="card-header">
                      <h3>Search Engine Optimization</h3>
                    </div>
                    <div className="card-body">
                      <div class="mb-3">
                        <label for="metaTitle" class="form-label">Meta Title</label>
                        <input type="text" class="form-control" id="metaTitle" name="meta_title" placeholder="Enter meta title"
                          onChange={handleChange}
                          onBlur={handleBlur}
                          value={values.meta_title}
                        />
                      </div>
                      <div class="mb-3">
                        <label for="metaDescription" class="form-label">Meta Description</label>
                        <textarea class="form-control" id="metaDescription" name="meta_description" rows="3" placeholder="Enter meta description"  onChange={handleChange}
                          onBlur={handleBlur}
                          value={values.meta_description}></textarea>
                      </div>
                      <div class="mb-3">
                        <label for="metaKeywords" class="form-label">Meta Keywords</label>
                        <input type="text" class="form-control" id="metaKeywords" name="meta_keywords" placeholder="e.g. electronics, gadgets, accessories" onChange={handleChange}
                          onBlur={handleBlur}
                          value={values.meta_keywords}/>
                      </div>
                      <div class="mb-3">
                        <label for="canonicalUrl" class="form-label">Canonical URL</label>
                        <input type="text" class="form-control" id="canonicalUrl" name="canonical_url" placeholder="https://example.com/category" onChange={handleChange}
                          onBlur={handleBlur}
                          value={values.canonical_url}/>
                      </div>
                      <div class="mb-3">
                        <label for="robots" class="form-label">Robots</label>
                        <input type="text" class="form-control" id="robots" name="robots" placeholder="index, follow" onChange={handleChange}
                          onBlur={handleBlur}
                          value={values.robots}/>
                      </div>
                      <hr />
                      <h5 style={{marginBottom:10}}>Open Graph (Facebook)</h5>
                      <div class="mb-3">
                        <label for="ogTitle" class="form-label">OG Title</label>
                        <input type="text" class="form-control" id="ogTitle" name="og_title" placeholder="Enter OG title" onChange={handleChange}
                          onBlur={handleBlur}
                          value={values.og_title}/>
                      </div>
                      <div class="mb-3">
                        <label for="ogDescription" class="form-label">OG Description</label>
                        <textarea class="form-control" id="ogDescription" name="og_description" rows="3" placeholder="Enter OG description"
                          onChange={handleChange}
                          onBlur={handleBlur}
                          value={values.og_description}
                        ></textarea>
                      </div>
                      <div class="mb-3">
                        <label for="ogImage" class="form-label">OG Image URL</label>
                        <input type="text" class="form-control" id="ogImage" name="og_image" placeholder="https://example.com/image.jpg" 
                          onChange={handleChange}
                          onBlur={handleBlur}
                          value={values.og_image}
                        />
                      </div>
                      <hr />
                      <h5 style={{marginBottom:10}}>Twitter Card</h5>
                      <div class="mb-3">
                        <label for="twitterTitle" class="form-label">Twitter Title</label>
                        <input type="text" class="form-control" id="twitterTitle" name="twitter_title" placeholder="Enter Twitter title" 
                          onChange={handleChange}
                          onBlur={handleBlur}
                          value={values.twitter_title}
                        />
                      </div>
                      <div class="mb-3">
                        <label for="twitterDescription" class="form-label">Twitter Description</label>
                        <textarea class="form-control" id="twitterDescription" name="twitter_description" rows="3" placeholder="Enter Twitter description"  onChange={handleChange}
                          onBlur={handleBlur}
                          value={values.twitter_description}></textarea>
                      </div>
                      <div class="mb-3">
                        <label for="twitterImage" class="form-label">Twitter Image URL</label>
                        <input type="text" class="form-control" id="twitterImage" name="twitter_image" placeholder="https://example.com/twitter-image.jpg" onChange={handleChange}
                          onBlur={handleBlur}
                          value={values.twitter_image}/>
                      </div>
                    </div>
                  </div>
              </form>
            )}
          </Formik>
        </div>
      </div>

    </>
  );
};

export default EditCategory;
